import React, { useEffect, useContext } from "react";
import { useIntl } from "react-intl";

import { version } from "../../../package.json";

import * as Path from "../Constants/GlobalConstant";
import { Link } from "react-router-dom";

import { faTwitterSquare, faLinkedin, faGithubSquare, faFacebookSquare } from "@fortawesome/free-brands-svg-icons";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { ThemeContext } from "../Context/ThemeWrapper";

import LogService from "../../middleware/CommonSdk/LogService";

const LOG_TAG = "FOOTER";

const Footer = () => {
    const intl = useIntl();
    const themeContext = useContext(ThemeContext);

    const linkToAle = "https://www.al-enterprise.com/";
    const linkToRainbow = "https://www.openrainbow.com/";
    const linkPartner = "https://www.al-enterprise.com/en/partners/dspp";
    const linkCookie = "https://www.al-enterprise.com/en/legal/cookie-policy";
    const linkLegal = "https://www.al-enterprise.com/en/legal";

    useEffect(() => {
        window.version = version;
        LogService.info(LOG_TAG, "webSite version :" , version);
    }, []);

    return (
        <footer id="footer">
            <hr />
            <div className="container-fluid">
                <div className="row">
                    <div className="col-lg-3 mb-3">
                        <div>
                            {themeContext.theme === "light" && <img src="./images/rainbow_dev_hub.png" alt="Logo" style={{ width: "164px" }} />}
                            {themeContext.theme === "dark" && <img src="./images/rainbow_dev_hub_dark.png" alt="Logo" style={{ width: "164px" }} />}
                        </div>
                        <div className="mt-3">
                            <p className="mb-0">&copy; Copyright - 2022 | &nbsp;
                                <a
                                    target="_blank"
                                    rel="noopener noreferrer"
                                    href={linkToAle}
                                >
                                    ALE International
                                </a>
                            </p>
                            <p>{document.title + " v" + version}</p>
                        </div>
                        <div className="mt-3">
                            <a target="_blank" className="btn btn-facebook btn-sm mr-1"
                                rel="noopener noreferrer"
                                href="http://www.facebook.com/ALUEnterprise">
                                <FontAwesomeIcon icon={faFacebookSquare} size="2x" /></a>
                            <a target="_blank" className="btn btn-twitter btn-sm mr-1"
                                rel="noopener noreferrer"
                                href="http://twitter.com/ALUEnterprise"><FontAwesomeIcon icon={faTwitterSquare} size="2x" /></a>
                            <a target="_blank" className="btn btn-linkedin btn-sm mr-1"
                                rel="noopener noreferrer"
                                href="https://www.linkedin.com/company/alcatellucententerprise"><FontAwesomeIcon icon={faLinkedin} size="2x" /></a>
                            <a target="_blank" className="btn btn-github btn-sm mr-1"
                                rel="noopener noreferrer"
                                href="https://github.com/Rainbow-CPaaS"
                            ><FontAwesomeIcon icon={faGithubSquare} size="2x" />
                            </a>
                        </div>
                    </div>
                    <div className="col-6 col-lg-2">
                        <h6 className="text-uppercase">{intl.messages.footerProduct}</h6>
                        <ul className="list-unstyled">
                            <li><Link to={Path.WEB_PATH}>{intl.messages.menuDocWeb} </Link></li>
                            <li><Link to={Path.NODE_PATH}>Node</Link></li>
                            <li><Link to={Path.ANDROID_PATH}>Android</Link></li>
                            <li><Link to={Path.IOS_PATH}>iOS</Link></li>
                            <li><Link to={Path.REACTNATIVE_PATH}>React Native</Link></li>
                            <li><Link to={Path.CSHARP_PATH}>{intl.messages.menuDocCSharp} </Link></li>
                            <li><Link to={Path.APIS_PATH}>{intl.messages.menuDocApi} </Link></li>
                        </ul>
                    </div>
                    <div className="col-6 col-lg-2">
                        <h6 className="text-uppercase">{intl.messages.footerLink}</h6>
                        <ul className="list-unstyled">
                            <li><Link to="/doc/hub/getting-started">{intl.messages.menuHeaderDocumentation}</Link></li>
                            <li><Link to={Path.STORE_PATH}>{intl.messages.menuStore}</Link></li>
                            <li><Link to={Path.SUPPORT_PATH}>{intl.messages.menuDocSupport}</Link></li>
                            <li><Link to={Path.LEARN_PATH}>{intl.messages.menuDocLearn}</Link></li>
                            <li><Link to={Path.PRICING_PATH}>{intl.messages.menuDocPricing}</Link></li>
                        </ul>
                    </div>
                    <div className="col-6 col-lg-2">
                        <h6 className="text-uppercase">{intl.messages.footerExplore}</h6>
                        <ul className="list-unstyled">
                            <li><a target="_blank" href={linkLegal} rel="noopener noreferrer">{intl.messages.footerLegal}</a></li>
                            <li><a target="_blank" href="./legals/Rainbow_API_HUB_Services_Agreement_for_Developer.pdf" rel="noopener noreferrer">{intl.messages.footerAgreeService}</a></li>
                            <li><a target="_blank" href="./legals/Rainbow_API_HUB_Developer_Agreement.pdf" rel="noopener noreferrer">{intl.messages.footerAgreeDev}</a></li>
                            <li><a target="_blank" href={linkCookie} rel="noopener noreferrer">{intl.messages.footerCookie}</a></li>
                        </ul>
                    </div>
                    <div className="col-6 col-lg-2">
                        <h6 className="text-uppercase">{intl.messages.footerCompany}</h6>
                        <ul className="list-unstyled">
                            <li><a target="_blank" href={linkPartner} rel="noopener noreferrer">{intl.messages.menuDocPartner}</a></li>
                            <li><a target="_blank" href={linkToAle} rel="noopener noreferrer">{intl.messages.footerVisit}</a></li>
                            <li><a target="_blank" href={linkToRainbow} rel="noopener noreferrer">Rainbow</a></li>
                            <li><a href="mailto:support@openrainbow.com?subject=[RainbowForDevelopers] Sales support">{intl.messages.footerContact}</a></li>
                        </ul>
                    </div>

                </div>
            </div>
        </footer>
    );
}

export default Footer;